import {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {getCompositionById} from 'store/reducers/compositions';
import {ApplicationState} from 'store/rootReducer';
import useIndexedDB from 'utils/hooks/useIndexedDB';
import {CompositionDetailExtended} from 'utils/types/compositions';
import {WritePreparation} from 'APIs/letrusAPI/writePreparation/types';
import styles from './Annotations.module.scss';

export interface AnnotationsProps {
  writePreparation?: WritePreparation;
  composition?: ImmutableMap<CompositionDetailExtended>;
}

function Annotations({
  writePreparation,
  composition,
}: AnnotationsProps): JSX.Element {
  const [localWritePreparation, setLocalWritePreparation] =
    useState<WritePreparation>();

  const writePreparationIDB = useIndexedDB<WritePreparation>(
    'LocalWritePreparations',
  );

  const parentId = composition?.get('parent_id');

  const isReviewGridMultigenre =
    composition?.getIn(['instruction_id', 'genre', 'review_grid']) === 61;
  const isMultigenreRewriting = isReviewGridMultigenre && !!parentId;

  useEffect(() => {
    writePreparationIDB
      .getItem(
        isMultigenreRewriting
          ? String(parentId)
          : String(composition?.get('id')),
      )
      .then((localWritePreparation) => {
        if (localWritePreparation) {
          setLocalWritePreparation(localWritePreparation);
        }
      });
  }, []);

  return (
    <div className={styles.annotations}>
      <h3>Anotações</h3>
      <textarea
        className={styles.annotationsContent}
        disabled
        value={
          localWritePreparation?.annotations ??
          writePreparation?.annotations ??
          'Anotações não foram feitas na etapa de preparação da escrita.'
        }
      />
    </div>
  );
}

export default connect((state: ApplicationState) => ({
  composition: getCompositionById(state),
}))(Annotations);
